import { render } from "./RecapCommande.vue?vue&type=template&id=4b7d3e04&scoped=true"
import script from "./RecapCommande.vue?vue&type=script&lang=js"
export * from "./RecapCommande.vue?vue&type=script&lang=js"

import "./RecapCommande.vue?vue&type=style&index=0&id=4b7d3e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7d3e04"]])

export default __exports__